import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanyBlockAppealResult } from '@doda/common/src/logics/companyBlock/determineCompanyBlockAppealState';

/**
 * 初期型
 */
export interface CompanyBlockAppealState {
  showConfirmPromptTodo: boolean;
  showSettingPromptTodo: boolean;
  showConfirmPromptModal: boolean;
}

/**
 * 初期状態
 */
export const companyBlockAppealInitialState: CompanyBlockAppealState = {
  showConfirmPromptTodo: false,
  showSettingPromptTodo: false,
  showConfirmPromptModal: false,
};

/**
 * slice
 */
export const companyBlockAppealSlice = createSlice({
  name: 'companyBlockAppeal',
  initialState: companyBlockAppealInitialState,
  reducers: {
    setCompanyBlockAppealState: (
      state,
      action: PayloadAction<CompanyBlockAppealResult>
    ) => {
      state.showConfirmPromptTodo = action.payload.showConfirmPromptTodo;
      state.showSettingPromptTodo = action.payload.showSettingPromptTodo;
      state.showConfirmPromptModal = action.payload.showConfirmPromptModal;
    },
  },
});

// Create Action
export const { setCompanyBlockAppealState } = companyBlockAppealSlice.actions;

// reducer
export const companyBlockAppealReducer = companyBlockAppealSlice.reducer;

// selector
interface State {
  companyBlockAppeal: CompanyBlockAppealState;
}

/**
 * showConfirmPromptTodoStateSelector
 * @param state
 * @returns showConfirmPromptTodo
 */
export const isShowConfirmPromptTodoSelector = <S extends State>(
  state: S
): boolean => state.companyBlockAppeal.showConfirmPromptTodo;

/**
 * showSettingPromptTodoStateSelector
 * @param state
 * @returns showSettingPromptTodo
 */
export const isShowSettingPromptTodoSelector = <S extends State>(
  state: S
): boolean => state.companyBlockAppeal.showSettingPromptTodo;

/**
 * showConfirmPromptModalStateSelector
 * @param state
 * @returns showConfirmPromptModal
 */
export const isShowConfirmPromptModalSelector = <S extends State>(
  state: S
): boolean => state.companyBlockAppeal.showConfirmPromptModal;
